import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../Common';
import services from "../services";
import { LoadingSpinerComponent } from "../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import { VarianceSchemaObject } from '../pages/tagExceptionSchema';
import { validateProperty, validate } from "../../Common";
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import _ from 'lodash';
import SimpleCard from '../components/card';
import Joi from '@hapi/joi';

const screenCode = "TAGMISSMATCHANDREPLACE";

export function TagMismatchAndReplace(props) {

    const childRef = useRef();

    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [unResolveTags, setUnResolveTags] = useState({});

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        toDate: ""
    });

    const [errors, setErrors] = useState({});
    const schema = Joi.object(VarianceSchemaObject).options({ allowUnknown: true });

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [selectedSearchValues.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown()
        )
    }, [selectedSearchValues.factoryID])

    function handleGroupChange(target) {
        setErrorsMsgs(target);

        setSelectedSearchValues({
            ...selectedSearchValues,
            groupID: target.value,
           
        });
    }

    function handleFactoryChange(target) {
        setErrorsMsgs(target);

        setSelectedSearchValues({
            ...selectedSearchValues,
            factoryID: target.value,
        });
    }

    function handleRouteChange(target) {
        setErrorsMsgs(target);

        setSelectedSearchValues({
            ...selectedSearchValues,
            routeID: target.value,
        });
    }

    function handleToDateChange(target) {
        setErrorsMsgs(target);
        
        setSelectedSearchValues({
            ...selectedSearchValues,
            toDate: target.value,
        });
    }

    function setErrorsMsgs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, VarianceSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];
        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWTAGMISSMATCHANDREPLACE');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setSelectedSearchValues({
            ...selectedSearchValues,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(selectedSearchValues.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(selectedSearchValues.factoryID);
        setRoutes(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    async function handleSearch() {
       // e.preventDefault();

        // const errorMessages = validate(schema, selectedSearchValues);
        // errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        // if (errorMessages) return;
         
        var model = {
            factoryID: parseInt(selectedSearchValues.factoryID),
            groupID: parseInt(selectedSearchValues.groupID),
            routeID: parseInt(selectedSearchValues.routeID),
            toDate: (selectedSearchValues.toDate).split('T')[0]
        };

        const unresolvedTagsResponse = await services.getAllUnResolvedFactoryWeighExceptionsByCP(model);
        setUnResolveTags(unresolvedTagsResponse);
    }

    const validateSearch = () => {
        if (selectedSearchValues.toDate !== '') {
            return false;
        }

        return true;
    }

    function onCancelClick() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            routeID: "0",
            date: ""
        });
        childRef.current.clearData();
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Tag Mismatch and Replace"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                // onSubmit={() => handleSearch()}
                                // disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={selectedSearchValues.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="factoryID"
                                            id="factoryID"
                                            name="factoryID"
                                            value={selectedSearchValues.factoryID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Route </InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={selectedSearchValues.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="searchDate">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onInput={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, selectedSearchValues)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={() => childRef.current.hanldeSearch()}

                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={() => childRef.current.clearData()}

                                    />
                                </div>
                            </form>

                            <SimpleCard ref={childRef} groupID={selectedSearchValues.groupID} factoryID={selectedSearchValues.factoryID} routeID={selectedSearchValues.routeID} toDate={selectedSearchValues.toDate}/>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
